<template>
  <div id="loginComponent">
    <v-facebook-login app-id="368967123860590"  v-model="model" @sdk-init="handleSdkInit" sdk-locale="vi_VN"
                      @login="login"
                      @logout="logout"
    >
      <slot name="login">Đăng nhập với Facebook</slot>
      <slot name="working">Vui lòng đợi ...</slot>

    </v-facebook-login>
    <div v-if="model.connected" class="user-info">
      <template v-if="userInfo && userInfo.id">
      <p>Thông tin tài khoản Facebook:</p>
      <div class="user-field">
        <span class="caption">Ảnh đại diện</span><img :src="'https://graph.facebook.com/'+ userInfo.id + '/picture?type=large'" alt="">
      </div>
      <div class="user-field">
        <span class="caption">Tên</span> <span>{{userInfo.name}}</span>
      </div>
      <div class="user-field">
        <span class="caption">Email</span> <span>{{userInfo.email}}</span>
      </div>
      </template>
    </div>

    <div v-if="checkout" class="login-checkout">
      <a href="/thanh-toan/" class="btn-checkout">Tiếp tục than toán</a>
    </div>

  </div>
</template>

<script>
  import VFacebookLogin from 'vue-facebook-login-component'
  export default {
    components: {
      VFacebookLogin
    },
    data: () => ({
      FB: {},
      model: {},
      scope: {},
      userInfo: null,
      checkout: false,
    }),
    created() {
      let url = new URL(window.location.href);
      let ts = url.searchParams.get("ts");
      if ('checkout' === ts) this.checkout = true;
    },
    methods: {
      handleSdkInit({ FB, scope }) {
        this.FB = FB
        this.scope = scope
      },
      async login (res) {
        this.FB.api('/me',{fields: 'email, name, picture'}, response => {
          this.userInfo = response;
          this.$store.dispatch('account/setUserFBInfo', response)
        });
      },
      logout(res) {
        this.userInfo = null;
        this.$store.dispatch('account/setUserFBInfo', null)
      }
    }
  }
</script>

<style scoped>
  .v-facebook-login {
    color: white!important;
    align-items: center;
    display: flex;
    margin: auto auto 2rem;
  }
  .user-info {
    background: #fff;
    border-radius: 8px;
    padding: 1rem;
    width: 355px;
    margin: 0 auto;
  }
  .user-info p {
    margin-bottom: 1rem;

  }
  .user-field {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
  }
  .user-field img {
    width: 64px;
    height: 64px;
    border-radius: 8px;
  }
  .user-field .caption {
    flex: 0 0 120px;
    font-weight: normal;
    font-size: 12px;
  }
  .user-field span:not(.caption) {
    font-size: 14px;
    font-weight: bold;
  }
  .login-checkout {
    margin: 1rem auto;
    text-align: center;
  }
  .btn-checkout {
    background: #158d00;
    border-radius: 4px;
    text-align: center;
    padding: 0.5rem 1rem;
    color: #fff!important;
  }

</style>



// WEBPACK FOOTER //
// src/components/LoginFB.vue